import React from "react";
import "./Menu.css";
import IMGLOGO from "../../assets/images/logo_horizontal.png";
import IMGBEHANCE from "../../assets/images/behance.png";
import IMGFACE from "../../assets/images/facebook.png";
import IMGYOUTUBE from "../../assets/images/youtube.png";
import IMGINSTA from "../../assets/images/instagram.png";

const Menu = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <div className="Menu ">
      <nav className="navbar navbar-expand-sm navbar-dark ">
        <div className="container">
          <div className="row w-100">
            <div className="col-lg-2 col-sm-2 col-6">
              <a href="/" className="navbar-brand h1">
                <img
                  src={IMGLOGO}
                  className="d-inline-block img-logo mt-3"
                  alt=""
                />
              </a>
            </div>
            <div className="col-lg-1 col-sm-2 col-6 d-flex justify-content-end">
              <button
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                className="navbar-toggler"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle Navigation"
              >
                <span className="navbar-toggler-icon "></span>
              </button>
            </div>
            <div
              className="collapse navbar-collapse col-lg-6 col-sm-5 justify-content-center pt-3"
              id="navbarNav"
            >
              <ul className="navbar-nav lista-nav">
                <li className="nav-item active">
                  <a
                    href="#home"
                    className="nav-link text-white active"
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item active">
                  <a
                    href="#videos"
                    className="text-white nav-link"
                  >
                    Vídeos
                  </a>
                </li>
                <li className="nav-item active">
                  <a
                    href="#fotos"
                    className="text-white nav-link"
                  >
                    Fotos
                  </a>
                </li>
                <li className="nav-item active">
                  <a
                    href="#servicos"
                    className="text-white nav-link"
                  >
                    Serviços
                  </a>
                </li>
                <li className="nav-item active">
                  <a
                    href="#sobre"
                    className="text-white nav-link"
                  >
                    Sobre
                  </a>
                </li>
                <li className="nav-item active">
                  <a
                    href="#contato"
                    className="text-white nav-link"
                  >
                    Contato
                  </a>
                </li>
                <li
                  className="nav-item active"
                  style={{ display: !matchResult ? "none" : "" }}
                >
                  <ul className="redes-sociais-lista pl-0 pt-4">
                    <li className="redes-sociais-icon d-inline p-1">
                      <a href="https://instagram.com/jotav.drone?igshid=YmMyMTA2M2Y=">
                        <img src={IMGINSTA} className="redes-icon-image" />
                      </a>
                    </li>
                    <li className="redes-sociais-icon d-inline p-1">
                      <a href="https://www.youtube.com/channel/UCvqAApTcRCPOZJCPes0BSSw">
                        <img src={IMGYOUTUBE} className="redes-icon-image" />
                      </a>
                    </li>
                    <li className="redes-sociais-icon d-inline p-1">
                      <img src={IMGFACE} className="redes-icon-image" />
                    </li>
                    <li className="redes-sociais-icon d-inline p-1">
                      <a href="https://www.behance.net/jotadrone">
                        <img src={IMGBEHANCE} className="redes-icon-image" />
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-sm-3">
              <div className="redes-sociais-header w-100 mt-lg-0 mt-sm-2 ml-sm-5 d-flex justify-content-end">
                <ul
                  className="redes-sociais-lista pl-0 pt-4"
                  style={{ display: matchResult ? "none" : "" }}
                >
                  <li className="redes-sociais-icon d-inline pr-3">
                    <a href="https://instagram.com/jotav.drone?igshid=YmMyMTA2M2Y=">
                      <img src={IMGINSTA} className="redes-icon-image" />
                    </a>
                  </li>
                  <li className="redes-sociais-icon d-inline pr-3">
                    <a href="https://www.youtube.com/channel/UCvqAApTcRCPOZJCPes0BSSw">
                      <img src={IMGYOUTUBE} className="redes-icon-image" />
                    </a>
                  </li>
                  <li className="redes-sociais-icon d-inline pr-3">
                    <img src={IMGFACE} className="redes-icon-image" />
                  </li>
                  <li className="redes-sociais-icon d-inline ">
                    <a href="https://www.behance.net/jotadrone">
                      <img src={IMGBEHANCE} className="redes-icon-image" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Menu;
